<div class="d-flex h-100">
  <div class="menu">
    <div class="menu-content">
      <img [src]="logo" routerLink="/home" matTooltip="Home" matTooltipPosition="right" width="50" alt="logo" id="logo" />

      <div class="menu-actions">
        <button
          mat-icon-button
          [attr.aria-label]="action.id"
          class="menu-actions-item"
          (click)="emitAction(action)"
          *ngFor="let action of actions"
          [class.active]="action.id === activeAction"
          [matTooltip]="action.label | translate"
          matTooltipPosition="right"
          matTooltipClass="info-button-tooltip"
        >
          <mat-icon>
            <span class="material-symbols-outlined" [ngClass]="{ 'fill-icon': action.fill }">
              {{ action.icon }}
            </span>
          </mat-icon>
        </button>
      </div>
    </div>

    <div class="menu-bottom">
      <ebw-notification-menu *ngIf="canSeeNotifications"></ebw-notification-menu>
      <ebw-monorepo-user-menu></ebw-monorepo-user-menu>
    </div>
  </div>

  <div class="home-grid" [class.grid-gap]="isSidePanelOpened" [class.wide-gap]="isWidePanelOpened" [class.half-gap]="isHalfPanelOpened">
    <div class="feature">
      <div class="sidenav-card" [@scaleAnimation] *ngIf="isSidePanelOpened">
        <div class="d-flex justify-content-end">
          <button mat-icon-button class="sidenav-card-back-btn" (click)="sidenavBack()" *ngIf="activeBack">
            <mat-icon>arrow_back</mat-icon>
          </button>

          <button mat-icon-button class="sidenav-card-back-btn" (click)="sidenavClose()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <router-outlet name="sidebarAction"></router-outlet>
      </div>
    </div>

    <div class="overflow-auto">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
